<script setup>
  import {computed, ref} from "vue";

  import ComponentCoreInfoDialogText from "@components/Dialogs/CoreInfoDialog/CoreInfoDialogText.vue";
  import {medicalInfoTypes} from "@components/Dialogs/CoreInfoDialog/enum.js";
  import ComponentDialog from "@components/Dialogs/Dialog.vue";
  import {MedButton} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "ComponentCoreInfoDialog",
  });

  const props = defineProps({
    dialogType: {
      type: String,
      default: "fi",
    },
  });

  const refCoreInfoDialog = ref(null);

  const alternativeSearch = ref(null);
  const currentDialogType = ref(props.dialogType);
  const payload = ref(null);
  const searchEnabled = ref(false);
  const title = ref("");
  const type = ref(medicalInfoTypes.text);

  const dialogWidth = computed(() => (currentDialogType.value === "fi" ? "medium" : "large"));

  const open = (data) => {
    if (data.type !== undefined) {
      currentDialogType.value = data.type;
    }

    if (data.referenceName !== undefined) {
      title.value = data.referenceName;
    } else if (data.dosagealternative !== undefined) {
      title.value = "Alternativsuche „" + data.fam + "“";
    }

    payload.value = data;
    refCoreInfoDialog.value.open();
  };

  const close = () => {
    refCoreInfoDialog.value.close();

    title.value = "";
    payload.value = null;
  };

  const enableSearch = (newValue) => {
    searchEnabled.value = newValue.enable;
  };

  const searchForAlternatives = () => {
    if (alternativeSearch.value) alternativeSearch.value.search();
  };

  defineExpose({
    open,
    close,
    enableSearch,
  });
</script>

<template>
  <ComponentDialog
    ref="refCoreInfoDialog"
    dialog-type="information"
    :dialog-width="dialogWidth"
    :test-id="getTestId('core-info')"
  >
    <template #content>
      <div v-if="type === medicalInfoTypes.text">
        <ComponentCoreInfoDialogText
          :data="payload"
          :dialog-type="currentDialogType"
          :test-id="getTestId('core-info-dialog')"
        />
      </div>

      <div v-else>Unbekannter Typ!</div>
    </template>

    <template #actions>
      <template v-if="type === medicalInfoTypes.alternative">
        <MedButton
          :disabled="!searchEnabled"
          :data-test="getTestId('core-info-dialog-search-for-alternatives-button')"
          @click="searchForAlternatives"
        >
          Jetzt suchen
        </MedButton>
      </template>

      <MedButton variant="primary" :data-test="getTestId('core-info-dialog-close-button')" @click="close">
        Schließen
      </MedButton>
    </template>
  </ComponentDialog>
</template>
